var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "region-store-pane" },
    [
      _c(
        "el-checkbox",
        {
          attrs: { indeterminate: _vm.isIndeterminate },
          on: { change: _vm.handleCheckAllChange },
          model: {
            value: _vm.checkAll,
            callback: function ($$v) {
              _vm.checkAll = $$v
            },
            expression: "checkAll",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.regionStore.regionName) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          on: { change: _vm.handleCheckedCitiesChange },
          model: {
            value: _vm.checkedStoreIds,
            callback: function ($$v) {
              _vm.checkedStoreIds = $$v
            },
            expression: "checkedStoreIds",
          },
        },
        _vm._l(_vm.regionStore.storeList, function (store) {
          return _c(
            "el-checkbox",
            { key: store.storeId, attrs: { label: store.storeId } },
            [_vm._v("\n      " + _vm._s(store.storeName) + "\n    ")]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }